import {
  getFirstCoownerData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { handleOnChangeDataFirstCoOwnerRenewal } from './helpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const onFirstCownerNameChange = {
  onFirstCoownerNameChange(initialRun?: boolean) {
    const { name } = getFirstCoownerData();
    const { coOwners } = getQuotation();

    const previousName = coOwners?.[0]?.name || '';

    if (checkHasDataChangedForRenewal(name, previousName)) {
      handleOnChangeDataFirstCoOwnerRenewal(initialRun);
    }

    setMainOwnerSelectionDictionary();
  },
};

export default onFirstCownerNameChange;
